import { createFileRoute } from '@tanstack/react-router'
import { BoardPage } from '~/components/renders/board-page'

export const Route = createFileRoute('/_authenticated/$workspaceSlug/renders/$projectId')({
  component: BoardPage,
})
